import { render, staticRenderFns } from "./tech-garbage-table.vue?vue&type=template&id=d0e9f366&lang=pug&"
import script from "./tech-garbage-table.vue?vue&type=script&lang=js&"
export * from "./tech-garbage-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports